export const DAY_TIME_BID_OPTION = {
    NONE: 'NONE',
    CUSTOM: 'CUSTOM',
};
